import LoadingIndicator from '@features/layout/components/LoadingIndicator';
import React, { ReactNode, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

interface ListingProps {
	loadMore: (skip: number, take: number) => Promise<any> | any;
	skip: number;
	take: number;
	hasMoreData: boolean;
	children: ReactNode;
}

interface ListingState {
	isLoading: boolean;
	skip: number;
	take: number;
}

const Listing = (listingProps: ListingProps) => {
	const { hasMoreData, loadMore, skip, take, children } = listingProps;
	const { formatMessage } = useIntl();

	const [state, setState] = useState<ListingState>({
		isLoading: false,
		skip,
		take,
	});

	const onLoadMoreClicked = useCallback(() => {
		if (!state.isLoading && hasMoreData) {
			setState((prevState) => ({ ...prevState, isLoading: true }));

			loadMore(state.skip, state.take)
				.then(() =>
					setState(({ take, skip }) => ({
						isLoading: false,
						skip: skip + 20,
						take: take,
					}))
				)
				.catch(() =>
					setState((prevState) => ({
						...prevState,
						isLoading: false,
					}))
				);
		}
	}, [hasMoreData, loadMore, state.isLoading, state.skip, state.take]);

	return (
		<>
			{children}
			{hasMoreData ? (
				<div className='flex w-full justify-center h-24 pt-5'>
					{!state.isLoading && hasMoreData ? (
						<button
							type='button'
							className='min-w-max py-4 px-6 h-14 bg-brightGray-200 text-brightGray-400 text-mxsm transition-colors
								font-bold rounded-2xl 
								focus:outline-none hover:bg-main-500 hover:text-white disabled:cursor-default disabled:bg-gray-200 disabled:text-black'
							onClick={() => onLoadMoreClicked()}
							data-testid='loadMoreBtn'
						>
							{formatMessage({ id: 'bcs-Common-LoadMore' })}
						</button>
					) : null}
					{state.isLoading ? <LoadingIndicator contained={true} /> : null}
				</div>
			) : null}
		</>
	);
};

export default Listing;
